module.exports = __webpack_public_path__ + "img/rupee.1e6c375c.svg";